import { Navigate } from "react-router-dom";
import { useStore } from "@/contexts/StoreContext";
import { useAuth } from "@/contexts/AuthContext";

interface PermissionRouteProps {
  permission?: string | string[];
  ownerOnly?: boolean;
  children: React.ReactNode;
}

export function PermissionRoute({
  permission,
  ownerOnly,
  children,
}: PermissionRouteProps) {
  const { hasPermission } = useStore();
  const { currentStore } = useAuth();

  if (ownerOnly && currentStore?.isOwner !== true) {
    return <Navigate to="/dashboard" replace />;
  }

  if (permission) {
    const required = Array.isArray(permission) ? permission : [permission];
    if (!required.some((item) => hasPermission(item))) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
